import { Button, CircularProgress, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { TEDFilterType, TEDFilterComponent, CountryCode, FilterFunction } from "./ted-filter-display";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";



export default function TEDFiltersPage({ }){

    let [tedFilters, setTEDFilters] = useState([] as TEDFilterType[]);
    let [isLoading, setIsLoading] = useState(false);

    function handleFilterUpdated(filter: TEDFilterType, index: number){
        let newFilter = filter;
        filter._id = tedFilters[index]._id;
        StorylineServerProxy.updateTEDFilter(newFilter).then(() => { loadFromServer(); });
    }

    function handleAddFilter(){
        let maxFilter = 0;
        tedFilters.forEach(filter => { maxFilter = Math.max(maxFilter, Number(filter.filterId))});
        let newFilter = { filterFunction: "matchCPV" as FilterFunction, country: "" as CountryCode, parameter:[], filterId: maxFilter + 1 };
        StorylineServerProxy.addTEDFilter(newFilter).then(() => {
            loadFromServer();
        })
    }

    function handleDeleteFilter(index: number){
        StorylineServerProxy.deleteTEDFilter(tedFilters[index]).then(() => {
            loadFromServer();
        })
    }

    function loadFromServer(){
        setIsLoading(true);
        const TEDFilters = StorylineServerProxy.allTEDFilters().then(data => {
            let filters = data.filters;
            filters.sort(function (a, b){ return b.filterId - a.filterId});
            setTEDFilters(filters);
            setIsLoading(false);
        });
    }

    useEffect(() => { 
        loadFromServer();
    }, []);

    return (
        <>
            <Paper elevation={6}  sx={{padding: 4}}>
                <Button onClick={handleAddFilter}>Add filter</Button>
            </Paper>
            <br/>
            {
                isLoading?<CircularProgress />:
                tedFilters.map((tedFilter, index) => {
                    return (
                        <>
                            <TEDFilterComponent key={index} TEDFilter={tedFilter} TEDFilterIndex={index} TEDFilterUpdated={handleFilterUpdated} deleteFilter={handleDeleteFilter}/>
                        </>
                    )
                })
            }
        </>
    )
}